import React from 'react';
import { HomePage } from './HomePage/HomePage';
import { UploadPage } from './UploadPage/UploadPage';
import { ProjectPage } from './ProjectPage/ProjectPage';
import { WaitingPage } from './WaitingPage/WaitingPage';

const App = () => {
  return (
    // <HomePage/>
    // <UploadPage/>
    <WaitingPage/>
  );
};

export default App;
